module.exports = __webpack_public_path__ + "img/Citra Angelina.8dcc695a.jpg";